import { render } from "./AccessUsersToOnlineOrders.vue?vue&type=template&id=d71c4378&scoped=true"
import script from "./AccessUsersToOnlineOrders.vue?vue&type=script&lang=js"
export * from "./AccessUsersToOnlineOrders.vue?vue&type=script&lang=js"

import "./AccessUsersToOnlineOrders.vue?vue&type=style&index=0&id=d71c4378&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d71c4378"]])

export default __exports__